export const IMAGES_PER_PAGE = 25;

export const BULK_DOWNLOAD_LIMIT = 25;

export const THUMBNAIL_SIZE = 178;

export const ORDER_BY = {
  LISTINGS_CONNECTED: 'connected_listing_count',
  PHOTO_EDITED_DATE: 'created_at',
};

export const ORDER_LABEL = {
  [ORDER_BY.LISTINGS_CONNECTED]: 'Listings connected',
  [ORDER_BY.PHOTO_EDITED_DATE]: 'Photo edited date',
};
